import promiseClient from 'hub-http/adapters/promiseClient';
import { environmentUrl, hubletApi } from 'hub-http/middlewares/core';
import * as core from 'hub-http/middlewares/core';
// @ts-expect-error Untyped module
import * as debug from 'hub-http/middlewares/debug';
import { createStack } from 'hub-http';
import noAuthClient from 'hub-http/clients/noAuthApiClient';
import { getHubletAndEnvOverrides } from '../utils/urls';
import Env from 'enviro';
import { HUBSPOT_COM, HUBSPOTQA_COM } from '../constants/domains';
let paymentsClient = null;
export const isHubSpotAppDomain = hostname => {
  const subdomain = hostname.split('.')[0];
  return (subdomain === 'app' || subdomain.startsWith('app-')) && (hostname.endsWith(HUBSPOT_COM) || hostname.endsWith(HUBSPOTQA_COM));
};
const createPaymentsClient = async () => {
  const hostname = window.location.hostname;
  const {
    hublet: customDomainHubletOverride,
    env: customDomainEnvOverride
  } = await getHubletAndEnvOverrides(hostname);
  if (customDomainEnvOverride) {
    Env.set('ENV', customDomainEnvOverride);
  }
  const paymentsApi = environmentUrl(hubletApi('payments', 'hubspot', customDomainHubletOverride, true));
  const paymentsStack = createStack(core.services, core.jsonBody, core.httpsOnly, core.withQuery, debug.rewriteUrl, debug.enableFailureInjection, core.reportOptionsError, core.validateStatus, core.jsonResponse, paymentsApi);
  return isHubSpotAppDomain(hostname) ? noAuthClient : promiseClient(paymentsStack);
};

/** avoid importing getPaymentsClient directly, use withPaymentsClient() HOF instead, to ensure consistent client initialization */
export const getPaymentsClient = async () => {
  if (!paymentsClient) {
    paymentsClient = await createPaymentsClient();
  }
  return paymentsClient;
};
export const withPaymentsClient = callback => async args => {
  const client = await getPaymentsClient();
  return callback(client, args);
};